const routes = {
  root: '/onboard-assessment/details',
}

export default routes
